import React, { useEffect, useState } from "react"
import styled from "styled-components"
import { Link } from "gatsby"

import { Subscribe } from "unstated"
import RPContainer from "../store"

import { AuthContainer } from "../stores/auth"
import { LogoDiv } from "./LandingBodyHelpers"

import helpBlueIcon from "../imgs/help-blue.svg"
import helpIcon from "../imgs/help.svg"
import menuIcon from "../imgs/menu.svg"
import closeIcon from "../imgs/close.svg"
import plus from "../imgs/plus.svg"
import plusBlue from "../imgs/plus-blue.svg"
import wheel from "../imgs/wheel.svg"
import wheelBlue from "../imgs/wheel-blue.svg"
import arrowDropUp from "../imgs/arrow_drop_up.svg"
import arrowDropDown from "../imgs/arrow_drop_down.svg"
import { get } from "lodash"
// import resources from "../imgs/resources.svg"
// import resourcesBlue from "../imgs/resources_blue.svg"

const MyMobileNavbar = styled.div`
  left: 0;
  width: 100%;
  top: 0;
  padding: 12px 0;
  z-index: 1;
  position: fixed;
  overflow: hidden;
  box-sizing: border-box;
  border: 1px solid #f1f1f1;
  .link {
    text-decoration: none;
  }
`

const NavbarBackground = styled.div`
  background-color: #ffffff;
  opacity: 1;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
  box-sizing: border-box;
`

const NavbarBody = styled.div`
  z-index: 1;
  position: relative;
  max-width: 930px;
  margin: 0 auto;
`

const NavbarBodyFirstChild = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
  box-sizing: border-box;
  .mobile-nav-div {
    width: 100%;
    padding: 0 30px;
    margin: 0 auto;
  }
  .mobile-nav-div-child {
    display: flex;
    justify-content: space-between;
  }
  .mobile-nav-overlay {
    background: rgba(0, 0, 0, 0.5);
    position: fixed;
    z-index: 999;
    top: 0;
    left: 0;
    width: 100vw;
    height: 0;
    opacity: 0;
    visibility: hidden;
    overflow: hidden;
    transition: all 0.25s cubic-bezier(0.46, 0.03, 0.55, 0.95);
    .overlay-menu-wrapper {
      background: #ffffff;
      box-shadow: 0px 2px 8px rgba(25, 42, 62, 0.1);
      border-radius: 8px;
      max-height: 90%;
      overflow-y: scroll;
      padding: 16px 15px;
      margin: 12px 16px;
      color: #a2a2a2;
      font-weight: 400;
      font-size: 18px;
      line-height: 22px;
      text-transform: uppercase;
      .last-div {
        margin: 0 0 0 14px;
        display: flex;
        justify-content: center;
        flex-direction: row;
        align-items: center;
      }

      .last-div-child {
        padding: 0;
        display: inline-block;
        text-decoration: none;
        color: #a2a2a2;
        padding-top: 24px;
      }
      .last-div-reseller {
        border-bottom: 1px solid #f1f1f1;
        margin: 0;
        .last-div-child {
          padding: 16px 0;
        }
      }
      .menu-list {
        margin-top: 20px;
      }
      .menu-list-inner {
        margin: 0;
        padding: 0;
      }
    }
  }
  .mobile-nav-overlay-active {
    visibility: visible;
    height: 100vh;
    opacity: 1;
  }
`

const NavbarBodySecondChild = styled.div`
  height: env(safe-area-inset-bottom);
  display: block;
  box-sizing: border-box;
`

const SingleNav = styled.div`
  .link {
    text-decoration: none;
    color: ${props => props.color};
    // border-bottom: 1px solid #111;
    padding: 12px 0;
  }
  .link-item {
    display: flex;
    flex-direction: row;
    align-items: center;
    border-bottom: 1px solid #f1f1f1;
  }
  .right-icon-wrapper {
    display: flex;
    align-items: center;
    margin-left: 12px;
  }
  .logo-wrapper {
    background-color: transparent;
    box-shadow: 0 0 0 1px ${props => props.color} inset;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 10px;
    width: 31px;
    height: 31px;
    min-width: 31px;
    min-height: 31px;
    border-radius: 50%;
    overflow: hidden;
    position: relative;
    user-select: none;
    transition: background-color 0.25s cubic-bezier(0.8, 0.3, 0.45, 0.95),
      box-shadow 0.25s cubic-bezier(0.8, 0.3, 0.45, 0.95);
  }
  .logo-child {
    width: 31px;
    height: 31px;
    min-width: 31px;
    min-height: 31px;
    position: relative;
    user-select: none;
    transition: color 0.25s cubic-bezier(0.8, 0.3, 0.45, 0.95),
      fill 0.25s cubic-bezier(0.8, 0.3, 0.45, 0.95);
    display: flex !important;
    align-items: center;
    flex-direction: column;
    justify-content: center;
  }

  .logo-child-para {
    color: ${props => props.color};
    font-weight: 500;
    transition: color 0.25s cubic-bezier(0.8, 0.3, 0.45, 0.95),
      fill 0.25s cubic-bezier(0.8, 0.3, 0.45, 0.95);
    text-align: center;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0.3px;
    margin: 0;
    padding: 0;
    white-space: normal;
  }
  .link-title {
    font-family: "Lato";
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 19px;
  }
  .child-nav-wrapper {
    max-height: 0;
    height: auto;
    overflow: hidden;
    transition: max-height 0.5s cubic-bezier(0.8, 0.3, 0.45, 0.95);
  }
  .child-nav-wrapper.active {
    max-height: 300px;
  }
`

const SingleNavItemInner = props => {
  const {
    link: { children, path },
  } = props
  if (children) {
    return <div className="link">{props.children}</div>
  }
  return (
    <Link className="link" to={path}>
      {props.children}
    </Link>
  )
}

const SingleNavItem = ({ link, rpStore, location }) => {
  const [openChildMenu, setOpenChildMenu] = useState(false)

  return (
    <SingleNav
      color={location.pathname.match(link.path) ? "#667af4" : "#a2a2a2"}
      onClick={() => {
        link.children && setOpenChildMenu(!openChildMenu)
      }}
    >
      <SingleNavItemInner link={link}>
        <div className="link-item">
          <div className="logo-wrapper">
            <div className="logo-child">{link.icon && link.icon(rpStore)}</div>
          </div>
          <p className="link-title">{link.title}</p>
          {link.children && (
            <div className="right-icon-wrapper">
              <img
                src={openChildMenu ? arrowDropUp : arrowDropDown}
                alt="dropdown"
              />
            </div>
          )}
        </div>
      </SingleNavItemInner>
      {link.children && (
        <div className={`child-nav-wrapper ${openChildMenu ? "active" : ""}`}>
          {link.children.map(childLink => (
            <SingleNavItem
              link={childLink}
              rpStore={rpStore}
              location={location}
              key={childLink}
            />
          ))}
        </div>
      )}
    </SingleNav>
  )
}

const MobileNav = ({ rpstore, location, authStore, isPublic }) => {
  const [openMenu, setOpenMenu] = useState(false)

  useEffect(() => {
    if (authStore.isAuthenticated) {
      rpstore.fetchSubscriptions()
    }
  }, [authStore.isAuthenticated, rpstore])

  const notLoggedIn =
    typeof authStore.state.user === "undefined"
      ? isPublic
      : !authStore.state.user

  const navLinks = notLoggedIn
    ? [
        {
          path: "/contact-us",
          icon: () => (
            <img
              className="mdcl-child-img"
              src={
                location.pathname.match("/contact-us") ? helpBlueIcon : helpIcon
              }
              alt="help-sign"
            />
          ),
          title: "Help",
        },
      ]
    : [
        {
          path: "/proxies",
          icon: rpStore => (
            <p className="logo-child-para">
              {rpStore.state.allSubscriptions.length}
            </p>
          ),
          title: "All My Proxies",
        },
        {
          path: "/dataplans",
          icon: () => (
            <p className="logo-child-para" style={{ fontSize: "12px" }}>
              GB
            </p>
          ),
          title: "Data Plans",
        },
        {
          path: "/addaproxy",
          icon: () => (
            <img
              className="mdcl-child-img"
              src={location.pathname.match("addaproxy") ? plusBlue : plus}
              alt="plus-sign"
            />
          ),
          title: "add a proxy",
        },
        {
          path: "/settings/account",
          icon: () => (
            <img
              className="mdcl-child-img"
              src={
                location.pathname.match("/settings/account") ? wheelBlue : wheel
              }
              alt="setting-sign"
            />
          ),
          title: "Account",
        },
        {
          path: "/contact-us",
          icon: () => (
            <img
              className="mdcl-child-img"
              src={
                location.pathname.match("/contact-us") ? helpBlueIcon : helpIcon
              }
              alt="setting-sign"
            />
          ),
          title: "Help",
        },
        // {
        //   path: "#",
        //   icon: () => (
        //     <img
        //       className="mdcl-child-img"
        //       src={
        //         location.pathname.match("/resources")
        //           ? resourcesBlue
        //           : resources
        //       }
        //       alt="resource-sign"
        //     />
        //   ),
        //   title: "Resources",
        //   children: [
        //     {
        //       path: "/notifications",
        //       icon: () => (
        //         <img
        //           className="mdcl-child-img"
        //           src={
        //             location.pathname.match("/notifications")
        //               ? helpBlueIcon
        //               : helpIcon
        //           }
        //           alt="notification-sign"
        //         />
        //       ),
        //       title: "Knowledge Base",
        //     },
        //     {
        //       path: "/notifications",
        //       icon: () => (
        //         <img
        //           className="mdcl-child-img"
        //           src={
        //             location.pathname.match("/notifications")
        //               ? helpBlueIcon
        //               : helpIcon
        //           }
        //           alt="notification-sign"
        //         />
        //       ),
        //       title: "Q&A",
        //     },
        //   ],
        // },
        {
          path: "/notifications",
          icon: () => (
            <img
              className="mdcl-child-img"
              src={
                location.pathname.match("/notifications")
                  ? helpBlueIcon
                  : helpIcon
              }
              alt="notification-sign"
            />
          ),
          title: "Notifications",
        },
      ]
  const userId = get(authStore, "state.user.user_id", null)
  return (
    <MyMobileNavbar>
      <NavbarBody>
        <NavbarBodyFirstChild>
          <div className="mobile-nav-div">
            <div className="mobile-nav-div-child">
              <LogoDiv dark />
              <div className="menu-div" onClick={() => setOpenMenu(!openMenu)}>
                <img src={menuIcon} alt="menu" />
              </div>
            </div>
          </div>
          {/* {openMenu && ( */}
          <div
            className={`mobile-nav-overlay ${
              openMenu ? "mobile-nav-overlay-active" : ""
            }`}
          >
            <div className="overlay-menu-wrapper">
              <div className="menu-header">
                <div className="mobile-nav-div-child">
                  <LogoDiv dark />
                  <div
                    className="menu-div"
                    onClick={() => setOpenMenu(!openMenu)}
                  >
                    <img src={closeIcon} alt="close" />
                  </div>
                </div>
              </div>
              <div className="menu-list">
                <ul className="menu-list-inner">
                  {userId && <div>Customer ID: {userId}</div>}
                  {navLinks.map(link => (
                    <SingleNavItem
                      link={link}
                      rpStore={rpstore}
                      location={location}
                      key={link}
                    />
                  ))}
                </ul>
              </div>
              <div className="last-div last-div-reseller">
                <Link className="last-div-child" to="/resellerrequest">
                  Reseller Request
                </Link>
              </div>
              <div className="last-div">
                <a
                  className="last-div-child"
                  href="#log"
                  onClick={e => {
                    notLoggedIn ? authStore.login() : authStore.logout()
                    e.preventDefault()
                  }}
                >
                  sign {notLoggedIn ? "in" : "out"}
                </a>
              </div>
            </div>
          </div>
          {/* )} */}
        </NavbarBodyFirstChild>
        <NavbarBodySecondChild />
      </NavbarBody>
      <NavbarBackground />
    </MyMobileNavbar>
  )
}

export default function MobileNavbar(props) {
  return (
    <Subscribe to={[RPContainer, AuthContainer]}>
      {(rpstore, authStore) => (
        <MobileNav
          {...{
            rpstore,
            authStore,
            ...props,
          }}
        />
      )}
    </Subscribe>
  )
}
